import juice from 'juice';
import {flow} from 'lodash';

/*
 * Preprocessing.
 */

export const preprocessPastedHtml: (html: string) => string = flow([
  maybeFixSabreAssets,
  maybeInlineStyles,
  maybeExtractBody,
]);

function maybeInlineStyles(html: string): string {
  if (!html.includes('</style>')) {
    return html;
  }

  return juice(html);
}

/** Extracts the inner-most body content from the given HTML, if body tags are present. */
function maybeExtractBody(html: string): string {
  // Match the first <body> start tag up to and including the first </body> end tag, or the end of the string.
  const bodyMatch = html.match(/<body\b.*?>\s*([\s\S]*?)\s*(?:<\/body>|$)/);
  if (!bodyMatch) {
    return html;
  }

  // Recurse, if there were nested <body> tags (such as from Sabre) we now have straggling <body> start tags.
  return maybeExtractBody(bodyMatch[1]);
}

/**
 * Workaround for HTML copied from Sabre, an app used by travel agency clients.
 *
 * Altour (ITV) https://hq.frontapp.com/companies/26373 uses an app called Sabre that generates HTML
 * snippets with embedded "file://" images, which miraculously works in Outlook. To make this work
 * in Front, we are hosting these images in ext.frontapp.com.
 */
export function maybeFixSabreAssets(dirtyHtml: string): string {
  if (dirtyHtml.indexOf('Sabre Red Workspace') === -1) {
    return dirtyHtml;
  }

  return dirtyHtml.replace(
    /(<img[^>]+)src="file:\/[^"]+\/Sabre Red Workspace\/Profiles\/\w+\/configuration\/org\.eclipse\.osgi\/bundles\/\d+\/\d+\/\.cp\/images\/([^"]+)"/gi,
    '$1src="https://ext.frontapp.com/altour/Sabre+Red+Workspace/Profiles/S11F_1228/configuration/org.eclipse.osgi/bundles/732/1/.cp/images/$2"',
  );
}

/*
 * Heuristics.
 */

export function pastedHtmlIsComplex(html: string): boolean {
  return hasNestedTables(html);
}

function hasNestedTables(html: string): boolean {
  const regexp = /<table\b([\s\S]+?)<\/table>/g;
  const nextMatch = () => regexp.exec(html);

  let match = nextMatch();
  while (match) {
    const inner = match[1];
    if (inner.match(/<table\b/)) {
      return true;
    }

    match = nextMatch();
  }

  return false;
}
